// src/api/cms/landingPageApi.ts
import { cmsAxios } from "./config/axiosConfig";

interface LandingPagePayload {
  description: string;
  contentUrl: string;
}

interface LandingPageData {
  id: string;
  description: string;
  contentUrl: string;
  createdAt: string;
  updatedAt: string;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

// Create a new landing page
export const createLandingPage = async (
  payload: LandingPagePayload
): Promise<ApiResponse<LandingPageData>> => {
  const response = await cmsAxios.post<ApiResponse<LandingPageData>>(
    "/cms/landing-page/create",
    payload
  );
  return response.data;
};

// Update an existing landing page by ID
export const updateLandingPage = async (
  id: string,
  payload: LandingPagePayload
): Promise<ApiResponse<string>> => {
  const response = await cmsAxios.put<ApiResponse<string>>(
    `/cms/landing-page/${id}`,
    payload
  );
  return response.data;
};

// Get list of landing pages
export const listLandingPages = async (): Promise<
  ApiResponse<LandingPageData[]>
> => {
  const response = await cmsAxios.get<ApiResponse<LandingPageData[]>>(
    "/cms/landing-page/list"
  );
  return response.data;
};
